import { useBucket } from '@mc/experiments-react'
import { PAINTED_DOOR_V2_FLAG } from './constants'

export const usePaintedDoorV2Enabled = () => {
  const bucket = useBucket(PAINTED_DOOR_V2_FLAG)
  return bucket === 'variant_1'
}
